import { schema } from "normalizr";

const PaymentTermSchema = new schema.Entity("paymentTerms");
const PaymentTermArraySchema = new schema.Array(PaymentTermSchema);

export { PaymentTermSchema, PaymentTermArraySchema };